<section class="list-landing-skeleton-container">
  <div *ngIf="platform === PlatformEnum.desktop" class="banner-container">
    <ion-skeleton-text class="banner" animated></ion-skeleton-text>
    <div class="text">{{ 'i18n.lists.myLists' | translate }}</div>
  </div>
  <div class="main-container">
    <div class="topper">
      <ion-skeleton-text class="search" animated></ion-skeleton-text>
      <ion-skeleton-text class="filter" animated></ion-skeleton-text>
    </div>

    <ion-skeleton-text class="title" animated></ion-skeleton-text>

    <ion-skeleton-text class="subtitle" animated></ion-skeleton-text>

    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>

    <ion-skeleton-text class="title" animated></ion-skeleton-text>

    <ion-skeleton-text class="subtitle" animated></ion-skeleton-text>

    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>

    <ion-skeleton-text class="title" animated></ion-skeleton-text>

    <ion-skeleton-text class="subtitle" animated></ion-skeleton-text>

    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
  </div>
</section>
